import React, { useContext } from 'react';
import { EnforcementAlertsContext } from '../contexts/EnforcementAlertsContext';
import EnforcementAlertsModal from './EnforcementAlertsModal';

/**
 * Listens for enforcement alerts and shows the consolidated alert modal.
 * Alerts are fetched on mount and updated in real-time via Pusher (handled in EnforcementAlertsContext).
 * Must be rendered inside EnforcementAlertsProvider.
 */
const PositionLossListener = () => {
  const { pendingAlerts } = useContext(EnforcementAlertsContext);

  // Filter out manual lockout alerts from modal display (user intentionally set them)
  // but keep them in pendingAlerts for lockout check.
  // Also hide day-based alerts from prior ET calendar days (stale max trades / daily loss).
  // pendingAlerts now includes dismissed-but-still-active lockouts (dismissing only silences
  // the popup, it must not lift the restriction) — filter those out here so the popup doesn't
  // keep reappearing after the user acknowledges it.
  const alertsToShow = (pendingAlerts || []).filter((alert) => {
    if (alert.dismissed_at) return false;
    if (alert.rule_type === 'manual_lockout') return false;
    if (alert.rule_type === 'max_trades_per_day' || alert.rule_type === 'max_loss_per_day' || alert.rule_type === 'profit_target_per_day') {
      const startsAt = alert.starts_at || alert.created_at;
      if (!startsAt) return true;
      const todayET = new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
      const alertDateET = new Date(startsAt).toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
      return todayET === alertDateET;
    }
    return true;
  });

  if (!alertsToShow || alertsToShow.length === 0) return null;

  return <EnforcementAlertsModal alerts={alertsToShow} />;
};

export default PositionLossListener;
